export const HN_VELG_BEHANDLINGSSTED_FRONTEND = 'HN.VelgBehandlingssted.Frontend';
